export default {
    data() {
        return{
            activeName: 0
        }
    }
}


// WEBPACK FOOTER //
// ./src/components/diversifiedTransport2/diversifiedTransport.vue.js